import React, { Component } from 'react'
import autoBind from 'react-autobind'
import { Segment } from 'semantic-ui-react'
import Participant from './participant'

class LaterParticipants extends Component {
    constructor (props) {
        super(props)
        const contains = props.selectedParticipant && props.participants.some((participant) => {
            return participant.id === props.selectedParticipant
        })
        this.ref = contains ? React.createRef() : undefined
        autoBind(this)
    }

    componentDidMount () {
        const scrollEl = document.getElementById('later-participants')
        if (scrollEl && localStorage.getItem('sidebarScroll')) {
            scrollEl.scrollTop = localStorage.getItem('sidebarScroll')
        }
    }

    componentDidUpdate () {
        const scrollEl = document.getElementById('later-participants')
        if (scrollEl && localStorage.getItem('sidebarScroll')) {
            scrollEl.scrollTop = localStorage.getItem('sidebarScroll')
        }
    }

    render() {
        return (
            <Segment
                id="later-participants"
                className='later'
                style={{
                    flex: this.props.flex,
                    display: 'flex',
                    flexDirection: 'column',
                    minHeight: 0,
                    overflowY: 'auto'
                }}
            >
                {this.props.participants.map((p, index) => (
                    <Participant
                        key={`participant${p.id}`}
                        participant={p}
                        last={index === this.props.participants.length - 1}
                        selected={this.props.selectedParticipant === p.id}
                        timezone={this.props.timezone}
                        language={this.props.language}
                        onSelectParticipant={this.props.onSelectParticipant}
                    />
                ))}
            </Segment>
        )
    }
}

export default LaterParticipants



// WEBPACK FOOTER //
// ./src/components/participants/later-participants.js